export const OPERATOR_SURAT = 'operator_surat';
export const PENGENDALI_SURAT = 'pengendali_surat';
export const PENGELOLA_ARSIP = 'pengelola_arsip';
export const PEGAWAI = 'pegawai';
export const KABAG = 'kabag';
export const KADIV = 'kadiv';
export const DIREKTUR = 'direktur';
export const DIREKTUR_UTAMA = 'direktur_utama';
export const KOMISARIS_UTAMA = 'komisaris_utama';
export const KOMISARIS_INDEPENDEN = 'komisaris_independen';
